import { render, staticRenderFns } from "./matchMemberWinloseDetail.vue?vue&type=template&id=2201642f&lang=pug&"
import script from "./matchMemberWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./matchMemberWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports